import SignoutIcon from 'assets/menu-icon/signout.svg';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import { useContextAuthManager } from '../../../AuthManager';
import { Link } from '../Aside/Menu';

export const LogoutButton = () => {
  const { t } = useTranslation();
  const { logout } = useContextAuthManager();

  return (
    <OverlayTrigger placement="right" overlay={<Tooltip id={'logout'}>{t('logout')}</Tooltip>}>
      <Link
        href="#"
        className="nav-link btn btn-icon btn-clean btn-lg"
        data-toggle="tab"
        data-target="#logout"
        data-test="logoutButton"
        role="tab"
        onClick={(event) => {
          event.preventDefault();
          logout();
        }}
      >
        <span className="svg-icon svg-icon-lg">
          <SVG src={SignoutIcon} />
        </span>
      </Link>
    </OverlayTrigger>
  );
};
